import { connect } from 'react-redux';
import LaporanPemasukanUang from '../../../views/Library/LaporanPemasukanUang/LaporanPemasukanUang.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(LaporanPemasukanUang);
